"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
/* eslint-disable react-hooks/rules-of-hooks */
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const react_1 = tslib_1.__importDefault(require("react"));
const react_hooks_1 = require("@apollo/react-hooks");
const react_hanger_1 = require("react-hanger");
const react_use_1 = require("react-use");
const reactstrap_1 = require("reactstrap");
const Input_1 = tslib_1.__importDefault(require("reactstrap/lib/Input"));
const reusables_1 = require("../../../comps/reusables");
const TinySaveIndicator_1 = require("../../../comps/reusables/TinySaveIndicator");
const graphql_1 = require("../../../graphql");
const use_react_router_1 = tslib_1.__importDefault(require("use-react-router"));
const react_2 = require("@osmosys/react");
const EditableTitleName_1 = require("./EditableTitleName");
// interface IProps extends RouteComponentProps<{ id: string }> {}
exports.ContextDetail = () => {
    const { match } = use_react_router_1.default();
    const id = match.params.id;
    const queryResult = react_hooks_1.useQuery(graphql_1.context, {
        variables: {
            id,
        },
    });
    const [mutate, saveResult] = react_hooks_1.useMutation(graphql_1.updateContext, {
        variables: {
            id,
        },
    });
    return (react_1.default.createElement(exports.ContextDetailInner, { queryResult: queryResult, save: mutate, saveResult: saveResult }));
};
exports.ContextDetailInner = ({ queryResult, save, saveResult, }) => {
    var _a;
    const { data, loading, error } = queryResult;
    if (error) {
        // floatBottom
        return (react_1.default.createElement(react_2.OsmosysErrorAlert, { resource: "Context", action: "read", apolloError: error }));
    }
    if (loading) {
        return react_1.default.createElement(reusables_1.Loading, { useContainer: true });
    }
    const { context } = data;
    // Get a local copy of the Context to edit
    const localContextState = react_hanger_1.useSetState(context);
    const contextVariables = react_hanger_1.useArray(context && context.contextVariables
        ? Object.entries(context.contextVariables)
        : []);
    if (!context) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    const dupeKeys = react_1.default.useMemo(() => {
        const dupes = [...contextVariables.value].reduce((acc, [key]) => {
            const trimmedKey = key || '';
            acc[trimmedKey] = acc[trimmedKey] || 0;
            ++acc[trimmedKey];
            return acc;
        }, {});
        return Object.entries(dupes)
            .filter(([, count]) => {
            return count > 1;
        })
            .map(o => o[0]);
    }, [contextVariables.value]);
    react_use_1.useDebounce(() => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        if (dupeKeys && dupeKeys.length > 0) {
            return;
        }
        yield save({
            variables: {
                data: {
                    contextVariables: contextVariables.value.reduce((acc, [key, val]) => {
                        acc[key] = val;
                        return acc;
                    }, {}),
                    name: localContextState.state && localContextState.state.name,
                },
                id: context.id,
            },
        });
    }), 3 * 1000, [
        localContextState.state && localContextState.state.name,
        contextVariables.value,
        dupeKeys,
    ]);
    return (react_1.default.createElement(reactstrap_1.Form, null,
        react_1.default.createElement("header", { className: "m-3" },
            react_1.default.createElement(EditableTitleName_1.EditableTitleName, { name: (_a = localContextState.state) === null || _a === void 0 ? void 0 : _a.name, disabled: saveResult.loading, onChange: newName => {
                    localContextState.setState({
                        name: newName,
                    });
                } }),
            react_1.default.createElement("div", { className: "text-center m-1" },
                react_1.default.createElement("p", { className: "m-0" },
                    react_1.default.createElement(TinySaveIndicator_1.TinySaveIndicator, { loading: saveResult.loading, success: !!saveResult.data, errorString: dupeKeys && dupeKeys.length > 0 && 'Remove duplicates', error: saveResult.error, buffer: 3000 })))),
        contextVariables.value.length === 0 && (react_1.default.createElement("div", { className: "my-5 h-100" },
            react_1.default.createElement(react_2.OsmosysUndesiredState, { message: "There are no context variables" },
                react_1.default.createElement(reactstrap_1.Button, { color: "dark", size: "sm", type: "button", className: "mt-2", onClick: () => {
                        contextVariables.add(['', '']);
                    } }, "Add first context variable")))),
        contextVariables.value.length > 0 && (react_1.default.createElement(reusables_1.SmallCenteredLayout, null,
            contextVariables.value.map(([key, val], i) => {
                return (react_1.default.createElement(exports.ContextKeyValueFormGroup, { key: key, varKey: key, varValue: val, isDupe: dupeKeys.includes(key || ''), onChangeKey: str => {
                        const newA = [...contextVariables.value];
                        newA[i][0] = str;
                        contextVariables.setValue(newA);
                    }, onChangeValue: str => {
                        const newA = [...contextVariables.value];
                        newA[i][1] = str;
                        contextVariables.setValue(newA);
                    }, onDelete: () => {
                        contextVariables.removeIndex(i);
                    } }));
            }),
            react_1.default.createElement("div", { className: "text-center" },
                react_1.default.createElement(react_2.OsmosysTooltip, { label: "Add new context variable" },
                    react_1.default.createElement(reactstrap_1.Button, { color: "link", size: "sm", type: "button", className: "mt-2 text-dark p-0", onClick: () => {
                            contextVariables.add([['', '']]);
                        } },
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faPlusCircle, fixedWidth: true, size: "lg" }))))))));
};
exports.ContextKeyValueFormGroup = ({ varKey, varValue, onChangeKey, onChangeValue, isDupe }) => {
    return (react_1.default.createElement(reactstrap_1.Row, { className: "my-2" },
        react_1.default.createElement(reactstrap_1.Col, null,
            react_1.default.createElement(Input_1.default, { type: "text", placeholder: "Text to find", value: varKey, onChange: e => {
                    onChangeKey(e.target.value);
                }, invalid: isDupe })),
        react_1.default.createElement(reactstrap_1.Col, { className: "flex-shrink-1 flex-grow-0 flex-col-centered text-muted" },
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faArrowAltRight, fixedWidth: true })),
        react_1.default.createElement(reactstrap_1.Col, null,
            react_1.default.createElement(Input_1.default, { type: "text", placeholder: "Replacement text", value: varValue, onChange: e => {
                    onChangeValue(e.target.value);
                } }))));
};
exports.default = exports.ContextDetail;
//# sourceMappingURL=ContextDetail.js.map